{
  "account.backToSignIn": "Volver a iniciar sesión",
  "account.birthDate": "Fecha de nacimiento",
  "account.birthDateHint": "Por debajo de la edad exigida en tu país, a un festival no se va solo.",
  "account.childProfile": "Perfil infantil",
  "account.country": "País",
  "account.countryOption": "País: {{name}}",
  "account.day": "Día",
  "account.dayShort": "DD",
  "account.delete": "Eliminar mi cuenta",
  "account.deleteConfirm": "Eliminar definitivamente",
  "account.deleteExplain": "Se borrarán tu cuenta, tus grupos, tus ubicaciones compartidas y tus relevamientos, así como los perfiles infantiles vinculados. Es definitivo. El programa, tus favoritos y tus marcadores se quedan en este teléfono.",
  "account.deletePasswordHint": "Escribe tu contraseña para confirmar.",
  "account.deleted": "Tu cuenta ha sido eliminada.",
  "account.displayName": "Nombre mostrado",
  "account.email": "Correo electrónico",
  "account.forgot": "¿Has olvidado tu contraseña?",
  "account.invalidCredentials": "Dirección o contraseña incorrecta.",
  "account.invitationCode": "Código de invitación",
  "account.invitationHint": "El registro no está abierto: una cuenta se crea con un código que alguien te entrega.",
  "account.invitationInvalid": "Este código de invitación no es válido.",
  "account.invitationScanned": "Invitación reconocida: completa el formulario.",
  "account.month": "Mes",
  "account.monthShort": "MM",
  "account.newPassword": "Nueva contraseña",
  "account.open": "Cuenta",
  "account.password": "Contraseña",
  "account.passwordHint": "Doce caracteres como mínimo.",
  "account.registrationFailed": "El registro no ha podido completarse. Revisa los datos introducidos.",
  "account.resetCode": "Código recibido",
  "account.resetConfirm": "Cambiar la contraseña",
  "account.resetDone": "Contraseña cambiada. Inicia sesión con la nueva.",
  "account.resetExplain": "Escribe la dirección de tu cuenta: te enviaremos un código de seis cifras.",
  "account.resetInvalid": "Este código no es válido o ha caducado. Pide uno nuevo.",
  "account.resetSend": "Recibir un código",
  "account.resetSent": "Si alguna cuenta usa esta dirección, acabamos de enviarle un código. Es válido durante 15 minutos.",
  "account.signIn": "Iniciar sesión",
  "account.signOut": "Cerrar sesión",
  "account.signUp": "Crear una cuenta",
  "account.signedInAs": "Conectado como {{name}}",
  "account.title": "Mi cuenta",
  "account.toggleToSignIn": "Ya tengo una cuenta",
  "account.toggleToSignUp": "Todavía no tengo cuenta",
  "account.tooMany": "Demasiados intentos. Inténtalo de nuevo en unos minutos.",
  "account.tooYoung": "La cuenta debe crearla un adulto, que luego podrá vincularle un perfil infantil.",
  "account.unreachable": "Servidor inaccesible. Inténtalo de nuevo cuando vuelva la red.",
  "account.year": "Año",
  "account.yearShort": "AAAA",
  "aerial.download": "Descargar la vista aérea",
  "aerial.downloading": "Descargando…",
  "aerial.explain": "Una vista aérea del recinto, tomada con dron. Ocupa {{size}} MB en tu teléfono y se descarga una sola vez.",
  "aerial.failed": "No se ha podido descargar. Inténtalo con wifi.",
  "aerial.ready": "Vista aérea disponible sin conexión",
  "aerial.remove": "Borrar la vista aérea",
  "aerial.title": "Vista aérea",
  "aerial.wifiHint": "Mejor hacerlo antes de llegar, con wifi.",
  "common.cancel": "Cancelar",
  "common.close": "Cerrar",
  "common.retry": "Reintentar",
  "common.search": "Buscar",
  "crew.apiUnavailable": "Grupo no disponible: ningún servidor configurado",
  "crew.background.active": "Tu ubicación se envía incluso con el móvil en el bolsillo, más o menos cada minuto mientras te mueves.",
  "crew.background.allow": "Permitir la ubicación siempre",
  "crew.background.foregroundOnly": "Tus amigos solo te ven cuando la app está abierta.",
  "crew.background.notificationBody": "Hasta las {{time}}. Abre la app para detenerlo.",
  "crew.background.notificationTitle": "Compartiendo tu ubicación con {{crew}}",
  "crew.codeLabel": "Código del grupo",
  "crew.create": "Crear un grupo",
  "crew.error.festival": "Este festival aún no está en el servidor: no se puede crear un grupo.",
  "crew.error.notFound": "Ningún grupo tiene este código. Compruébalo con la persona que creó el grupo.",
  "crew.error.notMember": "Ya no formas parte de este grupo, o ha caducado.",
  "crew.error.refused": "El servidor rechazó la solicitud. Inténtalo más tarde.",
  "crew.error.session": "Tu sesión ha caducado. Vuelve a iniciar sesión.",
  "crew.error.tooMany": "Demasiados intentos. Inténtalo de nuevo en unos minutos.",
  "crew.join": "Unirse con un código",
  "crew.lastSeen": "Visto hace {{minutes}} min",
  "crew.lastSeenDays": "Visto hace {{days}} d",
  "crew.lastSeenHours": "Visto hace {{hours}} h",
  "crew.nameLabel": "Nombre del grupo",
  "crew.near": "Cerca de {{place}}",
  "crew.needAccount": "Se necesita una cuenta para unirse a un grupo",
  "crew.noCrew": "Aún no tienes grupo",
  "crew.noPosition": "No comparte su ubicación",
  "crew.offline": "Sin conexión: últimos datos conocidos",
  "crew.positionStale": "Ubicación antigua",
  "crew.rallyNeedPosition": "Activa tu ubicación para saber dónde está",
  "crew.rallyOnMap": "Encuentro del grupo",
  "crew.rallySetAt": "Fijado a las {{time}}",
  "crew.section.members": "El grupo",
  "crew.section.sharing": "Mi ubicación",
  "crew.setRally": "Definir aquí un punto de encuentro",
  "crew.shareCode": "Haz escanear este código o díctalo",
  "crew.shareOff": "Compartir ubicación desactivado",
  "crew.sharing.APPROXIMATE": "Zona aproximada",
  "crew.sharing.OFF": "No compartir",
  "crew.sharing.PRECISE": "Ubicación precisa",
  "crew.sharingFor": "Compartir {{hours}} h",
  "crew.sharingUntil": "Compartiendo hasta las {{time}}",
  "crew.showOnMap": "Ver en el plano",
  "crew.title": "Mi grupo",
  "crew.you": "Eres tú",
  "diary.empty": "Aún no has marcado ningún concierto",
  "diary.markSeen": "Estuve allí",
  "diary.notYet": "Aún no ha empezado",
  "diary.photosCount": "{{count}} foto(s) hechas durante el festival",
  "diary.photosDenied": "Acceso a las fotos denegado",
  "diary.photosExplain": "Las fotos se quedan en tu teléfono: no se copia ni se envía nada.",
  "diary.photosNone": "No se han encontrado fotos de ese periodo",
  "diary.photosPermission": "Permitir el acceso a las fotos",
  "diary.photosTitle": "Fotos de este festival",
  "diary.stats": "{{performances}} concierto(s) · {{artists}} artista(s) · {{days}} día(s)",
  "diary.unmarkSeen": "Quitar del cuaderno",
  "festival.checkedOn": "comprobado el {{date}}",
  "festival.reportHint": "¿Un error? Toca este aviso o mantén pulsado un concierto o un lugar.",
  "festival.source": "Programa tomado de: {{source}}",
  "festival.unofficial": "Página no oficial: información no verificada por el organizador.",
  "keyring.add": "Añadir un festival",
  "keyring.already": "Ya está en tus festivales",
  "keyring.change": "Cambiar de festival",
  "keyring.current": "Abierto ahora",
  "keyring.empty": "Todavía no has añadido ningún festival.",
  "keyring.noResult": "No se ha encontrado ningún festival.",
  "keyring.offline": "La búsqueda necesita red. Los festivales ya añadidos siguen disponibles.",
  "keyring.pinFailed": "Tu teléfono no ha podido añadir el icono.",
  "keyring.pinHint": "Un icono para este festival que abre la app directamente en él.",
  "keyring.pinShortcut": "Añadir a la pantalla de inicio",
  "keyring.remove": "Quitar",
  "keyring.removed": "Festival quitado. Su contenido sin conexión se ha borrado.",
  "keyring.search": "Nombre del festival o de la ciudad",
  "keyring.searchHint": "También puedes escanear tu entrada: el festival se añade solo.",
  "keyring.title": "Mis festivales",
  "lineup.all": "Programa completo",
  "lineup.cancelled": "Cancelado",
  "lineup.conflict": "Se solapa con otro concierto de tus favoritos",
  "lineup.conflictLine": "{{first}} y {{second}} se solapan {{minutes}} min",
  "lineup.conflictsTitle": "{{count}} solapamiento(s) entre tus favoritos",
  "lineup.delayed": "Retrasado",
  "lineup.favorite": "Añadir a mis favoritos",
  "lineup.favoritesOnly": "Mis favoritos",
  "lineup.noPerformances": "No hay conciertos programados",
  "lineup.reminderBody": "{{artist}} en {{minutes}} min · {{stage}}",
  "lineup.reminderTitle": "Empieza pronto",
  "lineup.remindersPlanned": "{{count}} recordatorio(s) programado(s)",
  "lineup.remindersUnavailable": "Recordatorios no disponibles: notificaciones denegadas",
  "lineup.removeFavorite": "Quitar de favoritos",
  "lineup.title": "Programación",
  "location.denied": "Ubicación denegada: el plano sigue funcionando",
  "location.granted": "Ubicación activada",
  "mail.reset.body": "Hola, {{name}}:\n\nEste es tu código para elegir una nueva contraseña de Festipal:\n\n{{code}}\n\nEs válido durante {{minutes}} minutos. Si no lo has pedido, ignora este mensaje: tu contraseña no cambia.\n\nFestipal",
  "mail.reset.subject": "Tu código de Festipal: {{code}}",
  "map.bearing.east": "hacia el este",
  "map.bearing.north": "hacia el norte",
  "map.bearing.northeast": "hacia el noreste",
  "map.bearing.northwest": "hacia el noroeste",
  "map.bearing.south": "hacia el sur",
  "map.bearing.southeast": "hacia el sureste",
  "map.bearing.southwest": "hacia el suroeste",
  "map.bearing.west": "hacia el oeste",
  "map.closeDetail": "Cerrar",
  "map.distanceMeters": "a {{distance}} m",
  "map.listView": "Ver la lista de lugares",
  "map.loadError": "No se ha podido cargar el plano",
  "map.loading": "Preparando el plano…",
  "map.locateMe": "Localizarme",
  "map.offlineBadge": "Plano sin conexión",
  "map.offlineNotice": "Plano disponible sin conexión",
  "map.tapHint": "Toca un punto del plano para saber qué es.",
  "map.title": "Plano del recinto",
  "marker.car": "Mi coche",
  "marker.dropHere": "Colocar un marcador aquí",
  "marker.meeting": "Punto de encuentro",
  "marker.needLocation": "Se necesita la ubicación para colocar un marcador",
  "marker.other": "Marcador",
  "marker.remove": "Quitar este marcador",
  "marker.tent": "Mi tienda",
  "me.account": "Mi cuenta",
  "me.accountAnonymous": "Aún sin cuenta",
  "me.diary": "Mi cuaderno",
  "me.diaryCount": "{{count}} concierto(s) visto(s)",
  "me.festivals": "Mis festivales",
  "me.festivalsCount": "{{count}} festival(es) añadido(s)",
  "me.scan": "Escanear un código",
  "me.scanHint": "Entrada, invitación o grupo",
  "me.survey": "Cartografiar el recinto",
  "me.surveyHint": "Registrar los lugares que faltan",
  "me.title": "Yo",
  "ping.age": "Hace {{minutes}} min",
  "ping.cancel": "Ya nos encontramos",
  "ping.channel": "Llamadas del grupo",
  "ping.from": "{{name}}: «¡Ven conmigo!»",
  "ping.notificationBody": "Toca para ver dónde.",
  "ping.notificationTitle": "{{name}}: «¡Ven conmigo!»",
  "ping.onMap": "Ir con {{name}}",
  "ping.send": "Ven conmigo: enviar mi ubicación",
  "ping.sendHint": "Tu ubicación exacta se envía a tu grupo durante {{minutes}} min.",
  "ping.sent": "Llamaste a tu grupo a las {{time}}, hasta las {{until}}.",
  "places.allCategories": "Todos",
  "places.awaitingLocation": "Obteniendo tu ubicación…",
  "places.count": "{{count}} lugar(es)",
  "places.direction": "{{distance}} m {{bearing}} · {{minutes}} min a pie",
  "places.fromHere": "Calcular distancias desde este lugar",
  "places.locationUnavailable": "Ubicación no disponible: lugares ordenados por nombre",
  "places.noResult": "Ningún lugar coincide",
  "places.originDevice": "Distancias desde mi ubicación",
  "places.originManual": "Distancias desde {{place}}",
  "places.pickOrigin": "Elige un punto de referencia en la lista",
  "places.searchPlaceholder": "Buscar un lugar",
  "places.title": "Lugares",
  "places.unverified": "Sin verificar",
  "places.useMyLocation": "Usar mi ubicación",
  "poi.category.accessible": "Acceso para PMR",
  "poi.category.bar": "Bar",
  "poi.category.charging": "Carga de móvil",
  "poi.category.entrance": "Entrada",
  "poi.category.exit": "Salida de emergencia",
  "poi.category.firstaid": "Puesto de socorro",
  "poi.category.food": "Restauración",
  "poi.category.info": "Punto de información",
  "poi.category.lockers": "Consigna",
  "poi.category.stage": "Escenario",
  "poi.category.toilets": "Aseos",
  "poi.category.water": "Punto de agua",
  "report.comment": "Cuéntanos más si quieres (opcional)",
  "report.failed": "No se ha aceptado. Inténtalo más tarde.",
  "report.festival": "El programa o el plano en general",
  "report.kind.CANCELLED": "Cancelado",
  "report.kind.GONE": "No existe (ya)",
  "report.kind.MISSING": "Falta un concierto o un lugar",
  "report.kind.OTHER": "Otra cosa",
  "report.kind.WRONG_PLACE": "Mal situado",
  "report.kind.WRONG_STAGE": "Escenario equivocado",
  "report.kind.WRONG_TIME": "Horario equivocado",
  "report.offline": "Sin conexión: no se ha enviado nada. Inténtalo cuando vuelva la red.",
  "report.openSource": "Ver la fuente",
  "report.send": "Enviar",
  "report.sent": "¡Gracias! Ha llegado a quien mantiene esta página.",
  "report.title": "Avisar de un error",
  "report.tooMany": "Demasiados avisos seguidos. Inténtalo dentro de unos minutos.",
  "safety.callEmergency": "Llamar a emergencias",
  "safety.emergencyTitle": "Asistencia y socorro",
  "safety.nearestFirstAid": "Puesto de socorro más cercano",
  "scan.close": "Cerrar el escáner",
  "scan.crewFound": "Grupo reconocido: {{code}}",
  "scan.festivalFound": "Festival reconocido: {{slug}}",
  "scan.hint": "Escanea tu entrada o el código de un grupo",
  "scan.invitationFound": "Invitación reconocida",
  "scan.open": "Escanear un código",
  "scan.permission": "Permitir la cámara",
  "scan.permissionDenied": "Cámara denegada: escribe el código a mano",
  "scan.privacy": "Solo se lee el identificador del festival. No se guarda nada más de la entrada.",
  "scan.title": "Escanear",
  "scan.unknown": "Código no reconocido. Si viene de una venta de entradas, busca tu festival en la lista.",
  "shortcut.add": "Añadir",
  "shortcut.later": "Más tarde",
  "shortcut.offer": "¿Añadir {{name}} a tu pantalla de inicio?",
  "survey.addPhoto": "Añadir una foto",
  "survey.category": "Tipo de lugar",
  "survey.comment": "Detalle útil (opcional)",
  "survey.intro": "Camina hasta el lugar que quieres registrar, quédate quieto mientras mide y ponle nombre.",
  "survey.measuring": "{{used}} mediciones conservadas · precisión {{accuracy}} m",
  "survey.moderationNotice": "Cada registro se revisa antes de aparecer en la aplicación.",
  "survey.name": "Nombre del lugar",
  "survey.needAccount": "Se necesita una cuenta: un registro se atribuye a su autor.",
  "survey.needLocation": "Se necesita acceso a la ubicación para registrar un punto.",
  "survey.open": "Cartografiar",
  "survey.photoAttached": "Foto adjunta",
  "survey.photoRejected": "Foto descartada por el filtro automático. El registro sí se ha enviado.",
  "survey.queue": "Mis registros",
  "survey.queueEmpty": "Todavía no hay registros.",
  "survey.rejected": "{{count}} medición(es) descartada(s), demasiado lejos de las demás",
  "survey.removePhoto": "Quitar la foto",
  "survey.save": "Guardar el registro",
  "survey.send": "Enviar ahora",
  "survey.sendFailed": "No se puede enviar ahora. Los registros permanecen en el dispositivo.",
  "survey.sending": "Enviando…",
  "survey.start": "Empezar la medición",
  "survey.statusPending": "Esperando red",
  "survey.statusRejected": "Registro rechazado por el servidor.",
  "survey.statusSent": "Enviado",
  "survey.stop": "Detener la medición",
  "survey.title": "Cartografía sobre el terreno",
  "survey.tooImprecise": "La precisión sigue siendo insuficiente. Aléjate de las estructuras metálicas y espera.",
  "survey.waiting": "Esperando al GPS…",
  "tab.crew": "Grupo",
  "tab.diary": "Cuaderno",
  "tab.lineup": "Programa",
  "tab.map": "Plano",
  "tab.me": "Yo",
  "tab.places": "Lugares"
}
